module.exports = __webpack_public_path__ + "static/img/5.f9f3185.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/5.png
// module id = I5YJ
// module chunks = 0